import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import ExperienceInsightsActions from './experience-insights-actions';

const initialState = Immutable({
  byId:          {},
  isInitialLoad: true,
  isLoading:     false,
});

const reducer = createReducer(on => {
  //=============================================
  // EXPERIENCE TOTALS
  //=============================================

  on(ExperienceInsightsActions.fetchExperienceTotalsSuccess, (state, { experienceId, totals }) => {
    return state.merge({
      isLoading: false,
      byId:      {
        [experienceId]: totals,
      },
    });
  });

  on(ExperienceInsightsActions.bootstrapExperienceInsights, state => state.set('isLoading', true));
  on(ExperienceInsightsActions.bootstrapExperienceInsightsSuccess, state =>
    state.merge({ isInitialLoad: false, isLoading: false })
  );
  on(ExperienceInsightsActions.bootstrapExperienceInsightsFailure, (state, { error }) => state.merge(initialState));
}, initialState);

export default reducer;
